import { render, staticRenderFns } from "./modalManageSeasonTicketTags.vue?vue&type=template&id=b5e4f01a&"
import script from "./modalManageSeasonTicketTags.vue?vue&type=script&lang=js&"
export * from "./modalManageSeasonTicketTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports